import { useState } from "react";
import { useLocation } from "react-router-dom";
import Invoices from "./Invoices";
import PriceFiles from "./PriceFiles";
import UploadStatus from "./UploadStatus";
import { PageHeader, SubTabs } from "../components/dc";
import usePageTitle from "../hooks/usePageTitle";

// Merged "Data" hub — the three ingestion surfaces as sub-tabs (fix #4). The
// existing pages are embedded wholesale, so every upload/filter/delete handler
// and API call is preserved exactly. Legacy routes (/invoices, /price-files,
// /upload-status) still resolve to the same components in App.js.
const TABS = [
  { key: "upload-status", label: "Upload Status" },
  { key: "price-files", label: "Price Files" },
  { key: "invoices", label: "Invoices" },
];

// Deep-link support: /data?tab=price-files (or the legacy paths) opens the right tab.
function initialTab(search, pathname) {
  const q = new URLSearchParams(search).get("tab");
  if (TABS.some((t) => t.key === q)) return q;
  if (pathname.includes("price-files")) return "price-files";
  if (pathname.includes("invoices")) return "invoices";
  return "upload-status";
}

export default function DataHub() {
  usePageTitle("Data");
  const loc = useLocation();
  const [tab, setTab] = useState(() => initialTab(loc.search, loc.pathname));

  return (
    <div>
      <PageHeader title="Data" subtitle="Ingested invoice lines, uploaded supplier price files, and background-job progress" />
      <div style={{ marginBottom: 20 }}>
        <SubTabs tabs={TABS} active={tab} onChange={setTab} />
      </div>
      {tab === "invoices" && <Invoices />}
      {tab === "price-files" && <PriceFiles />}
      {tab === "upload-status" && <UploadStatus />}
    </div>
  );
}
